import { Action } from '../../actions';
import { CANCEL_FREELANCER_SERVICE_BY_CLIENT_SUCCESS } from '../../actions/freelancers/feedback-form';
import { REQUEST_COOP_BY_CUSTOMER_SUCCESS } from '../../actions/freelancers/freelancer-accept-popup';
import {
    CLOSE_ACCEPT_FREELANCER_COOP_REQUEST_BY_CLIENT,
    FETCH_FREELANCER_CARD_DATA,
    FREELANCER_CARD_UPDATE_CUSTOMER_PHONE,
    HANDLE_UPDATE_FREELANCER_STATUS_ERROR,
    HANDLE_UPDATE_FREELANCER_STATUS_SUCCESS,
    OPEN_ACCEPT_FREELANCER_COOP_REQUEST_BY_CLIENT,
    RELEASE_FREELANCER_CARD,
    SET_FREELANCER_CARD_ERROR,
    SET_FREELANCER_CARD_NOT_FOUND,
    UPDATE_FREELANCER_CARD_DATA,
    UPDATE_FREELANCER_CARD_PRIVATE_DATA,
    UPDATE_FREELANCER_CUSTOMER_DATA,
    UPDATE_FREELANCER_STATUS,
    WITHDRAW_REQUEST_BY_CLIENT_ERROR,
    WITHDRAW_REQUEST_BY_CLIENT_START,
    WITHDRAW_REQUEST_BY_CLIENT_SUCCESS
} from '../../actions/freelancers/freelancer-card';
import {
    ADD_FREELANCER_FEEDBACK_SUCCESS,
    DELETE_FREELANCER_FEEDBACK_SUCCESS,
    UPDATE_FREELANCER_FEEDBACK_SUCCESS
} from '../../actions/freelancers/freelancer-feedback';
import { FreelancerPageStates } from '../../typings/freelancers';
import { GdFreelancerStatus } from '../../typings/graphql-grid';
import { FreelancerCardState, State } from '../../typings/state';

export const initialState = {
    freelancer: undefined,
    customer: undefined,
    pageState: FreelancerPageStates.PENDING,
    isAcceptRequestPending: false,
    isWithdrawRequestPending: false,
    isFreelancerFeedbackFormPending: false,
    cooperationBlockState: FreelancerPageStates.LOADED,
    acceptRequestByClientPopupIsOpen: false
};

export const freelancerCard = (
    state: FreelancerCardState = initialState,
    action: Action,
    fullState: State
): FreelancerCardState => {
    switch (action.type) {
        case FETCH_FREELANCER_CARD_DATA:
            return {
                ...state,
                pageState: FreelancerPageStates.PENDING
            };
        case UPDATE_FREELANCER_CARD_DATA:
            return {
                ...state,
                freelancer: action.freelancer,
                operator: action.operator
            };
        case SET_FREELANCER_CARD_ERROR:
            return {
                ...state,
                pageState: FreelancerPageStates.ERROR,
                error: action.error
            };
        case SET_FREELANCER_CARD_NOT_FOUND:
            return {
                ...state,
                pageState: FreelancerPageStates.NOT_FOUND
            };
        case UPDATE_FREELANCER_CUSTOMER_DATA:
            return {
                ...state,
                customer: action.payload.customer,
                freelancer: state.freelancer && {
                    ...state.freelancer,
                    freelancerFeedbackItems: action.payload.feedbacks
                }
            };
        case UPDATE_FREELANCER_CARD_PRIVATE_DATA:
            return {
                ...state,
                freelancer: state.freelancer && {
                    ...state.freelancer,
                    ...action.payload
                }
            };
        case RELEASE_FREELANCER_CARD:
            return {
                ...state,
                pageState: FreelancerPageStates.LOADED
            };
        case CANCEL_FREELANCER_SERVICE_BY_CLIENT_SUCCESS:
            return {
                ...state,
                customer: state.customer && {
                    ...state.customer,
                    freelancerProject: undefined
                }
            };
        case ADD_FREELANCER_FEEDBACK_SUCCESS:
            if (!state.freelancer || state.freelancer.freelancerId !== action.freelancerId) {
                return state;
            }
            return {
                ...state,
                freelancer: state.freelancer && {
                    ...state.freelancer,
                    freelancerFeedbackItems: [
                        {
                            ...action.payload
                        },
                        ...state.freelancer.freelancerFeedbackItems
                    ]
                }
            };
        case UPDATE_FREELANCER_FEEDBACK_SUCCESS:
            return {
                ...state,
                freelancer: state.freelancer && {
                    ...state.freelancer,
                    freelancerFeedbackItems: state.freelancer.freelancerFeedbackItems.map(item => {
                        if (item.id !== action.payload.id) {
                            return item;
                        }

                        return {
                            ...item,
                            freelancerScore: action.payload.freelancerScore,
                            feedbackText: action.payload.feedbackText,
                            creationTime: action.payload.creationTime,
                            willRecommend: action.payload.willRecommend,
                            moderationStatus: action.payload.moderationStatus
                        };
                    })
                }
            };
        case DELETE_FREELANCER_FEEDBACK_SUCCESS:
            return {
                ...state,
                freelancer: state.freelancer && {
                    ...state.freelancer,
                    freelancerFeedbackItems: state.freelancer.freelancerFeedbackItems.filter(
                        ({ id }) => id !== action.payload.feedbackItemId
                    )
                }
            };
        case REQUEST_COOP_BY_CUSTOMER_SUCCESS:
            return {
                ...state,
                acceptRequestByClientPopupIsOpen: false,
                customer: state.customer && {
                    ...state.customer,
                    freelancerProject: {
                        projectId: action.data.projectId,
                        ownFreelancerId: action.data.freelancerId,
                        ownFreelancerLogin: action.data.projectFreelancerLogin,
                        clientStatus: action.data.clientStatus,
                        createdTime: action.data.projectCreatedTime,
                        startedTime: action.data.projectStartedTime
                    }
                }
            };
        case UPDATE_FREELANCER_STATUS:
            return {
                ...state,
                cooperationBlockState: FreelancerPageStates.PENDING
            };
        case HANDLE_UPDATE_FREELANCER_STATUS_SUCCESS:
            return {
                ...state,
                cooperationBlockState: FreelancerPageStates.LOADED,

                freelancer: state.freelancer && {
                    ...state.freelancer,
                    status: GdFreelancerStatus[action.status]
                }
            };
        case HANDLE_UPDATE_FREELANCER_STATUS_ERROR:
            return {
                ...state,
                cooperationBlockState: FreelancerPageStates.ERROR
            };
        case OPEN_ACCEPT_FREELANCER_COOP_REQUEST_BY_CLIENT:
            return {
                ...state,
                acceptRequestByClientPopupIsOpen: true
            };
        case CLOSE_ACCEPT_FREELANCER_COOP_REQUEST_BY_CLIENT:
            return {
                ...state,
                acceptRequestByClientPopupIsOpen: false
            };
        case WITHDRAW_REQUEST_BY_CLIENT_START:
            return {
                ...state,
                isWithdrawRequestPending: true
            };
        case WITHDRAW_REQUEST_BY_CLIENT_SUCCESS:
            return {
                ...state,
                customer: state.customer && {
                    ...state.customer,
                    freelancerProject: undefined
                },
                isWithdrawRequestPending: false
            };
        case WITHDRAW_REQUEST_BY_CLIENT_ERROR:
            return {
                ...state,
                isWithdrawRequestPending: false
            };
        case FREELANCER_CARD_UPDATE_CUSTOMER_PHONE:
            return {
                ...state,
                customer: state.customer && {
                    ...state.customer,
                    phone: action.value
                }
            };
        default:
            return state;
    }
};
